export default __webpack_public_path__ + "static/media/softarch.a069c7c9.png";